<div [ngClass]="isOfferApplicable? 'line-through text-slate-500' : ''"
  class="flex justify-content-between align-items-baseline">
  <p class="mt-0 text-md"><ng-content></ng-content></p>
  <div class="flex flex-column justify-content-center align-items-end">
    <div class="m-0 p-0 flex justify-content-center align-items-baseline">
      <h3 class="text-lg my-0">{{cost | currency }}</h3>
      <h3 class="text-lg my-0" *ngIf="showPerMonth">{{ hasPerMonth ? (numberOfInstallments === 3 ? '/payment' : '/mo') :
        '/yr'}}</h3>
    </div>
    <p *ngIf="hasSubTitle" class="text-xs my-1">({{yearCost | currency}}/year)</p>
  </div>
</div>